// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"161":"f48a65a6b7e37d6c2952","1766":"12acc2c421d9366fae6e","2097":"721ce5a7aeb4689c15f8","7494":"7be200a786fc32750a7b","8278":"929176ac5608213dc576"}[chunkId] + ".js";
};